export default __webpack_public_path__ + "static/media/Irrigation_Management.53fbc409.webp";